<template>

    <div class="littleArticleArticle">
        <div class="littleArticleArticle_img" v-if="image">
            <img :src="imgPath(image)"  />
        </div>
        <div class="littleArticleArticle_title" v-movingLine="{delay: 2000}" v-html="title"></div>
        <div class="littleArticleArticle_subtitle" v-html="subtitle"></div>
        <div class="littleArticleArticle_keyfigure">{{ keyfigure }}</div>
        <div class="littleArticleArticle_content">
            <Collapser :noCollapse="noCollapse" :middleCollapse="middleCollapse">
                <div v-html="content"></div>

                <div class="littleArticleArticle_event" v-for="event in events">
                    <div class="littleArticleArticle_event_date">{{ event.date }}</div>
                    <div class="littleArticleArticle_event_title">{{ event.title }}</div>
                </div>

                <p class="littleArticleArticle_caption" v-html="caption"></p>
                <p class="littleArticleArticle_link">
                    <a :href="`http://${link}`" target="_blank" v-for="link in links">
                        {{ link }}
                    </a>
                </p>
            </Collapser>
        </div>
        <div class="littleArticleArticle_img" v-if="imageBottom">
            <img :src="imgPath(imageBottom)"  />
        </div>
    </div>

</template>



<script>
    import Collapser from "./Collapser";
    export default {
        name: 'LittleArticle',
        components: {Collapser},
        props: {
            image: {
                type: String,
                default: '',
            },
            title: {
                type: String,
                default: 'title',
            },
            subtitle: {
                type: String,
                default: '',
            },
            keyfigure: {
                type: String,
                default: '',
            },
            content: {
                type: String,
                default: '',
            },
            imageBottom: {
                type: String,
                default: '',
            },
            link: {
                type: String,
                default: '',
            },
            caption: {
                type: String,
                default: '',
            },
            events: {
                type: Array
            },
            noCollapse: {
                type: Boolean,
                default: false,
            },
            middleCollapse: {
                type: Boolean,
                default: false,
            }
        },
        data: function(){
            return {
                links: []
            };
        },
        mounted: function(){
          this.links = this.link.split(' ');
        },
        methods: {
            imgPath: function(image){
                return require('../assets/img/'+image);
            },
        },
    };
</script>

<style scoped lang="scss">
    .littleArticleArticle{
        padding: 0 $G-default;
        overflow: hidden;

        &_img{
            margin-bottom:  $G-default;
        }
        &_title{
            text-transform: uppercase;
            font-size: 3rem;
            margin-bottom:  $G-default;
            font-weight: $FW-bold;
        }
        &_subtitle{
            font-size: 2.7rem;
            font-weight: $FW-semibold;
            margin-bottom:  $G-default/3;
        }
        &_keyfigure {
            font-family: $F-Montserrat;
            font-size: 8rem;
            font-weight: $FW-medium;
        }

        &_event{
            margin-bottom: $G-default;
            &_date{
                font-weight: $FW-semibold;
                text-transform: uppercase;
            }
        }

        &_caption {
            font-size: 1.5rem;
            margin-top: 1.5rem;
        }

        &_link {
            padding-bottom: 1rem;
            
            a {
                border-bottom: 1px solid $C-greylight;
            }
        }
    }
</style>